"use strict";
exports.__esModule = true;
exports.isDateWithinLastThreeDaysOfMonth = exports.formatDateString = exports.getMonthTValue = exports.isInBPWindow = exports.firstOfNextMonth = exports.fifteenthOfMonth = exports.firstOfMonth = exports.isTodayAfterProvidedDate = exports.calculateDifferenceBetweenTwoDates = exports.padLeft = exports.ordinalSuffixFor = exports.getNowServerTime = exports.getBillPayCutoffTime = exports.getServerTime = exports.getDateTimeFromISO = exports.getDateTime = exports.SERVER_TIMEZONE = void 0;
var luxon_1 = require("luxon");
var languages = {
    en: 'en-US'
};
exports.SERVER_TIMEZONE = 'UTC-5';
var getDateTime = function (selectedLanguage) {
    var localeValue = selectedLanguage ? languages[selectedLanguage] : languages.en;
    return luxon_1.DateTime.now().setLocale(localeValue || languages.en);
};
exports.getDateTime = getDateTime;
var getDateTimeFromISO = function (isoString, options, locale) {
    return luxon_1.DateTime.fromISO(isoString, options).setLocale(locale || languages.en);
};
exports.getDateTimeFromISO = getDateTimeFromISO;
var getServerTime = function (date) {
    return date.setZone(exports.SERVER_TIMEZONE);
};
exports.getServerTime = getServerTime;
var getBillPayCutoffTime = function (date) {
    return (0, exports.getServerTime)(date).set({ hour: 13, minute: 0, second: 0 });
};
exports.getBillPayCutoffTime = getBillPayCutoffTime;
var getNowServerTime = function () {
    return (0, exports.getServerTime)(luxon_1.DateTime.utc());
};
exports.getNowServerTime = getNowServerTime;
var ordinalSuffixFor = function (i, includeNum) {
    if (includeNum === void 0) { includeNum = true; }
    var j = i % 10;
    var k = i % 100;
    var numString = includeNum ? i : '';
    if (j === 1 && k !== 11) {
        return numString + 'st';
    }
    if (j === 2 && k !== 12) {
        return numString + 'nd';
    }
    if (j === 3 && k !== 13) {
        return numString + 'rd';
    }
    return numString + 'th';
};
exports.ordinalSuffixFor = ordinalSuffixFor;
var padLeft = function (i) {
    return i > 9 ? "".concat(i) : "0".concat(i);
};
exports.padLeft = padLeft;
var calculateDifferenceBetweenTwoDates = function (latterDate, earlierDate) {
    return Math.ceil((latterDate.getTime() - earlierDate.getTime()) / 1000 / 60 / 60 / 24);
};
exports.calculateDifferenceBetweenTwoDates = calculateDifferenceBetweenTwoDates;
// Compare two dates without taking time into consideration
var isTodayAfterProvidedDate = function (today, providedDate) {
    var yearIsAfter = today.year > providedDate.year;
    var monthIsAfter = today.year === providedDate.year && today.month > providedDate.month;
    var dayIsAfter = today.year === providedDate.year && today.month === providedDate.month && today.day > providedDate.day;
    return yearIsAfter || monthIsAfter || dayIsAfter;
};
exports.isTodayAfterProvidedDate = isTodayAfterProvidedDate;
var firstOfMonth = function () {
    return (0, exports.getServerTime)(luxon_1.DateTime.utc().set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }));
};
exports.firstOfMonth = firstOfMonth;
var fifteenthOfMonth = function () {
    return (0, exports.getServerTime)(luxon_1.DateTime.utc().set({ day: 15, hour: 0, minute: 0, second: 0, millisecond: 0 }));
};
exports.fifteenthOfMonth = fifteenthOfMonth;
var firstOfNextMonth = function () {
    return (0, exports.getServerTime)(luxon_1.DateTime.utc().plus({ months: 1 }).set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }));
};
exports.firstOfNextMonth = firstOfNextMonth;
/** `bpStart` and `bpEnd` are strings coming from customerStatus */
var isInBPWindow = function (bpStart, bpEnd) {
    var today = (0, exports.getNowServerTime)();
    var bpStartDate = (0, exports.getDateTimeFromISO)(bpStart);
    var bpEndDate = (0, exports.getDateTimeFromISO)(bpEnd);
    return today >= (0, exports.getServerTime)(bpStartDate) && today <= (0, exports.getServerTime)(bpEndDate);
};
exports.isInBPWindow = isInBPWindow;
/** Calculate days before or after the 1st of the month using T+{dayOffset} language for a calendar month
    Examples: dayOffset for T-1 would be -1, dayOffset for T+3 would be 3 */
var getMonthTValue = function (dayOffset, date) {
    if (dayOffset === void 0) { dayOffset = 0; }
    if (dayOffset < 0) {
        return date.set({ day: date.daysInMonth + 1 + dayOffset });
    }
    return date.set({ day: 1 + dayOffset });
};
exports.getMonthTValue = getMonthTValue;
var formatDateString = function (date, monthLong) {
    return "".concat(date.weekdayLong, ", ").concat(monthLong ? date.monthLong : date.monthShort, " ").concat(date.day);
};
exports.formatDateString = formatDateString;
var isDateWithinLastThreeDaysOfMonth = function (dateTime) {
    if (!dateTime)
        return false;
    var year = dateTime.year;
    var month = dateTime.month;
    var lastDayOfMonth = luxon_1.DateTime.local(year, month).endOf('month').day;
    var startOfLastThreeDays = lastDayOfMonth - 2;
    var dayOfMonth = dateTime.day;
    return dayOfMonth >= startOfLastThreeDays;
};
exports.isDateWithinLastThreeDaysOfMonth = isDateWithinLastThreeDaysOfMonth;
